export default {
  name: 'Rendering',
  functional: true,
  props: {
    render: [String, Function]
  },

  /** 
     * 渲染函数
     * @param {Function} h // 渲染方法
     * @param {Object} ctx // 数据
     */
  render: (h, ctx) => {
    if (typeof ctx.props.render === 'function') {
      return ctx.props.render(h);
    } else {
      return h('span', {class: 'x-grey-text'}, ctx.props.render);
    }
  }
};